import { type ICampaign } from '@/Interfaces/Campaign.interface';
import { CAMPAIGNS_ENDPOINT } from '@/constants/endpoints';
import axios from 'axios';

export const duplicateCampaign = async (id: number, name: string): Promise<ICampaign> => {
  const res = await axios.post(`${CAMPAIGNS_ENDPOINT}/${id}/duplicate`, { name });
  return res.data;
};
